import React from 'react'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import validator from 'email-validator'

import { addEmail, setUserSettings } from '../store/reducers/auth.js'
import { fetchingState } from './../helpers/hocs.js'

const locales = {
  en: { code: 'en', 'title': 'English' },
  ru: { code: 'ru', 'title': 'Русский' }
}

const Component = ({
  confirm,
  setEmail, error
}) => {
  function handleInputChange(event) {
    setEmail(event.target.value)
  }

  return (
  <div className='EmailPopup'>
    <h1 className='EmailPopup-h1'><FormattedMessage id='email_popup.add_email' /></h1>
    <div className='EmailPopup-kontainer'>
      <div className='EmailPopup-select'>
          <input 
			type="text"
			name="name"
			className='EmailPopup__field'
			onChange={handleInputChange}
			/>
      </div>
      <button className='EmailPopup-submit' onClick={confirm}><FormattedMessage id='email_popup.done' /></button>
    </div>
  </div>
)}

const mapDispatchToProps = dispatch => bindActionCreators({ addEmail, setUserSettings }, dispatch)

const mapState = state => ({
  countries: state.countries
})

export default _.compose(
  fetchingState(),
  injectIntl,
  connect(mapState, mapDispatchToProps),
  _.withState('email', 'setEmail', ""),
  _.withState('error', 'setError', ""),
  _.withStateHandlers(
    {
      countryId: window.localStorage.getItem('countryId'),
      locale: window.localStorage.getItem('locale')
    },
    {
      setLocale: () => e => ({ locale: e.target.value }),
      setCountry: () => e => ({ countryId: e.target.value })
    }
  ),
  _.withHandlers({
    confirm: ({ email, setError, addEmail, fetchingWrap, onClose, setUserSettings }) => async e => {
      e && e.preventDefault()
      
    if (!validator.validate(email)) {//неверный формат почты
        setError(true)
      }
      else {//адрес эл почты прошел проверку
        let result = await fetchingWrap(addEmail.bind(this, email ))
        if (result == 200) {
          onClose()
        }
        setError(false)
      }
    },
    changeField: () => e => {

    }
  }),
  _.branch(({ countries }) => !Object.keys(countries).length, _.renderNothing),
  _.lifecycle({
    componentWillMount () {
    }
  })
)(Component)



// WEBPACK FOOTER //
// ./src/components/EmailPopup.jsx